import { Anchor, Box, Text } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

import SimpleCard from '../components/SimpleCard';

/**
 * Reusable styled components for dashboard module cards across the application.
 * Used in applications, inquiries, leases, payments, and property condition modules.
 */

export const EmptyStateTitleText = styled(Text, {
  base: {
    textStyle: { base: 'heading-xs', md: 'heading-sm' },
    marginBottom: '200',
  },
});

export const EmptyStateBodyText = styled(Text, {
  base: {
    display: 'block',
    marginBottom: '600',
  },
});

export const NoUnderlineAnchor = styled(Anchor, {
  base: {
    textDecoration: 'none',
    color: 'inherit !important',
  },
});

export const StyledEmptySimpleCard = styled(SimpleCard, {
  base: {
    padding: '{spacing.1000} {spacing.600}',
    borderRadius: 'Card.Root !important',
  },
});

export const StyledEmptyStateContainer = styled(Box, {
  base: {
    textAlign: 'center',
    margin: '0 auto',
    maxWidth: '608px',
  },
});

export const StyledIconContainer = styled(Box, {
  base: {
    marginBottom: '200',
  },
});
